import PropTypes from "prop-types"
import AbsoluteLineChart from "components/charts/absolute-line-chart"
import Trend from "./trend"
import Tooltip from "./tooltip"
import { DATE, CHART_ITEM } from "helpers/shapes"
import "./style.scss"

function PerformanceHistory({ formatter, cumulativeTrend, alphaTrend, tradingPnl, factorTrend, residualTrend, startDate, endDate, date, setDate }) {
  const tooltipProps = { cumulativeTrend, alphaTrend, factorTrend, tradingPnl, residualTrend, formatter }
  const dateProps = { startDate, endDate, date, setDate }

  return <div className="components_performance-history">
    <h5 className="title">Cumulative Returns</h5>
    <Trend data={cumulativeTrend}>
      <AbsoluteLineChart label="total" tooltip={<Tooltip id="total" {...tooltipProps} />} data={cumulativeTrend} height={125} {...dateProps} formatter={formatter} />
    </Trend>
    <Trend data={alphaTrend}>
      <AbsoluteLineChart label="alpha" tooltip={<Tooltip id="alpha" {...tooltipProps} />} data={alphaTrend} height={125} {...dateProps} formatter={formatter} />
    </Trend>
    <Trend data={factorTrend}>
      <AbsoluteLineChart label="factor" tooltip={<Tooltip id="factor" {...tooltipProps} />} data={factorTrend} height={125} {...dateProps} formatter={formatter} />
    </Trend>
    {tradingPnl && <Trend data={tradingPnl}>
      <AbsoluteLineChart label="trading" tooltip={<Tooltip id="trading" {...tooltipProps} />} data={tradingPnl} height={125} {...dateProps} formatter={formatter} />
    </Trend>}
    {residualTrend && <Trend data={residualTrend}>
      <AbsoluteLineChart label="residual" tooltip={<Tooltip id="residual" {...tooltipProps} />} data={residualTrend} height={125} {...dateProps} formatter={formatter} />
    </Trend>}
  </div>
}

PerformanceHistory.propTypes = {
  startDate: DATE.isRequired,
  endDate: DATE.isRequired,
  date: DATE,
  cumulativeTrend: PropTypes.arrayOf(CHART_ITEM).isRequired,
  alphaTrend: PropTypes.arrayOf(CHART_ITEM).isRequired,
  factorTrend: PropTypes.arrayOf(CHART_ITEM).isRequired,
  tradingPnl: PropTypes.arrayOf(CHART_ITEM),
  residualTrend: PropTypes.arrayOf(CHART_ITEM),
  formatter: PropTypes.func.isRequired,
  setDate: PropTypes.func.isRequired,
}

export default PerformanceHistory
